import { getCurrencySymbol } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { WidgetStyleProps } from '@finxone-platform/shared/sys-config-types';

@Component({
  standalone: false,
  selector: 'finxone-platform-label-input',
  templateUrl: './label-input.component.html',
  styleUrls: ['./label-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => LabelInputComponent),
    },
  ],
})
export class LabelInputComponent implements OnInit, OnChanges {
  @Input() type = 'text';
  @Input() label = '';
  @Input() formControlName = '';
  @Input() value: any = '';
  @Input() labelAsPlaceholder?: boolean;
  @Input() placeholder = '';
  @Input() formGroup: FormGroup;
  @Input() textColor: WidgetStyleProps;
  @Input() colorTextAlignStyle: WidgetStyleProps;
  @Input() textInputFontStyle: WidgetStyleProps;
  @Input() textInputBackgroundColor: WidgetStyleProps;
  @Input() country = 'uk';
  @Input() currency = 'GBP';
  @Input() inputStyle: WidgetStyleProps = {};
  @Input() disable = false;
  @Output() public focusEvent = new EventEmitter<boolean>();
  public get currencySymbol() {
    return getCurrencySymbol(this.currency, 'narrow');
  }
  public readonly valueAccessorFormControl = new FormControl();
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};
  public combinedInputStyles: WidgetStyleProps = {};

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.combinedInputStyles = Object.assign(
      this.textInputBackgroundColor ?? {},
      this.textColor ?? {},
      this.textInputFontStyle ?? {},
      this.inputStyle ?? {},
    );
    this.colorTextAlignStyle = this.colorTextAlignStyle || {};
  }

  ngOnChanges(): void {
    this.combinedInputStyles = Object.assign(
      this.textInputBackgroundColor ?? {},
      this.textColor ?? {},
      this.textInputFontStyle ?? {},
      this.inputStyle ?? {},
    );
    this.colorTextAlignStyle = this.colorTextAlignStyle || {};
  }

  writeValue(value: string): void {
    value = value ?? '';
    this.valueAccessorFormControl.setValue(value);
    this.cd.markForCheck();
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  onFocusEvent = (event: boolean) => {
    this.focusEvent.emit(event);
  };
}
